import React from "react";
import { Add } from "@mui/icons-material";
import { Box, Button } from "@mui/material";
import { toast } from "react-toastify";

import VehicleRegistrationForm from "./VehicleRegistrationForm";
import FormDrawer from "components/Shared/FormDrawer";

import {
  useAddVehicleRegistrationMutation,
  useUpdateVehicleRegistrationMutation,
} from "store/services/vehicleApi";

import { useVehicleDetailContext } from "contexts/VehicleDetailContext";
import VehicleRegistrationList from "./VehicleRegistrationList";

const VehicleRegistrationTab = () => {

  const [showRegistrationForm, setShowRegistrationForm] = React.useState(false);

  const [selectedRegistration, setSelectedRegistration] = React.useState(null);

  const { vehicleDetail } = useVehicleDetailContext();

  // RTK Query
  const [addVehicleRegistration, { isLoading: addingRegistration }] = useAddVehicleRegistrationMutation();

  const [updateVehicleRegistration, { isLoading: updatingRegistration }] = useUpdateVehicleRegistrationMutation();

  // Methods
  const handleCancelRegistration = () => {
    setShowRegistrationForm(false);
    setSelectedRegistration(null);
  };

  const handleAddOrUpdateRegistration = async (data) => {
    try {
      if (selectedRegistration) {
        await updateVehicleRegistration({
          vehicleId: vehicleDetail?._id,
          registrationId: selectedRegistration._id,
          ...data,
        }).unwrap();
        toast.success("Registration updated successfully!");
      } else {
        await addVehicleRegistration({
          vehicleId: vehicleDetail?._id,
          ...data,
        }).unwrap();
        toast.success("Registration added successfully!");
      }
      handleCancelRegistration();
    } catch (err) {
      toast.error(err?.data?.message ?? "Couldn't process registration!");
    }
  };

  return (
    <>
      <Box display="flex" justifyContent="end" padding={3}>
        {!showRegistrationForm && (
          <Button
            startIcon={<Add />}
            variant="outlined"
            onClick={() => setShowRegistrationForm(true)}
          >
            Add Registration
          </Button>
        )}
      </Box>
      
      <VehicleRegistrationList/>

      <FormDrawer
        title="Vehicle Registration"
        open={showRegistrationForm}
        onClose={handleCancelRegistration}
      >
        <VehicleRegistrationForm
          isBusy={addingRegistration || updatingRegistration}
          vehicleRegistration={selectedRegistration}
          onCancel={handleCancelRegistration}
          onSubmit={handleAddOrUpdateRegistration}
        />
      </FormDrawer>
    </>
  );
};

export default VehicleRegistrationTab;